export default [
    {
      path: '/',
      redirect: '/login',
      // meta: {
      //   title: '登录'
      // }
    },
    
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '财务中台'
      }
    },
    
    {
      path: '/main',
      name: 'main',
      component: () => import('@/views/main/index'),
      meta: {
        title: '财务中台'
      },
    },


    

]
  